import React from 'react';

import SetoCanvasPage from 'pages/SetoCanvasPage';
import {Separator, Title, Button} from 'views/AppElements';
import SessionStore from 'stores/SessionStore';
import AppConstants from 'AppConstants';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm} from 'views/FormElements';
import UserAPI from 'service/api/UserAPI';

const AccountDeactivatePage = (props, context) => {
    const history = props.history;
    const urlId = props.match.params.userId;
    const userId = urlId? urlId: SessionStore.getCurrentSession().user.id;

    const validationScheme = () => {
		return Yup.object().shape({
		    userInput: Yup.string().required('Please enter the text "deactivate".')
                                    .oneOf(['deactivate'], 'Please enter the text "deactivate".'),
		});
	}

    const handleSubmission = () => {
        UserAPI.deactivateAccount(userId, () => {
            history.push("/");
        });
        
    };

    return (
        <SetoCanvasPage id="allArtistPage" title={"Nepals' Creative Artists Premium Hub | Seto Canvas"} metaDescription={"Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com"}>
            <Title title="We are sad to see you go :(" style={{textAlign: 'center'}} separatorPosition="bottom" />
            <h4 style={{lineHeight: '30px'}}>
                Deactivating your account will delete all of your designs, except the ones that have made some earnings. Once deactivated, your account and designs will no longer be visible in <b>{AppConstants.WEBSITE}</b>
            </h4>

            <h4 style={{lineHeight: '30px'}}>
                The designs that have made any earnings, will be <b>archived</b> and will no longer be able to accept any orders.
            </h4>

            <h4 style={{lineHeight: '30px'}}>
                Your earnings, if any, will be frozen too and you can always get it back logging in again.
            </h4>
            <Separator />
            <br /><br />
            
            <Formik enableReinitialize initialValues={{userInput: ''}} onSubmit={handleSubmission}
						validationSchema={validationScheme} render={({isSubmitting}) => {
							let submitBtn = "Submit";
		
							if(isSubmitting === true)
								submitBtn = <span>Submitting <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

							return <RGForm>
								<Input name="userInput" type="text" label={<p><i>Enter the text <b>deactivate</b> below to confirm deactivating your account:</i></p>} style={{marginBottom: "0px"}} />
								
								<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
									{submitBtn}
								</SubmitButton>
							</RGForm>
						}} />
        </SetoCanvasPage>
    );
};


export default AccountDeactivatePage;


// WEBPACK FOOTER //
// ./src/pages/AccountDeactivatePage.js